import { Alert, Avatar, Button, Card, Col, DatePicker, Divider, Input, InputNumber, Modal, Radio, Row, Select, Space, Spin, Statistic, Table, Tabs, Tag, Tooltip, Typography, Upload } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { UnorderedListOutlined, UploadOutlined } from '@ant-design/icons';
import { apiCall } from '../../../API/RestApi';
import { useSelector } from 'react-redux';
import moment from 'moment';
import Form from 'antd/es/form/Form';
import { exportToExcel } from '../export/ExportLeavePaid';
import dayjs from 'dayjs';
import * as XLSX from "xlsx";

function LeavePaidTimeOffNew() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(0);

    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10
        },
    });

    const [isModalDetail, setIsModalDetail] = useState(false);
    const [detailData, setDetailData] = useState(null);
    const [leaveHistory, setLeaveHistory] = useState([]);

    const [isModalForm, setIsModalForm] = useState(false);
    const [formMode, setFormMode] = useState("add");
    const [formData, setFormData] = useState(null);
    const [leaveAction, setLeaveAction] = useState(null); // add | cut

    const [isModalUpload, setIsModalUpload] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedExcel, setSelectedExcel] = useState("access");
    const [isModalExport, setIsModalExport] = useState(false);
    const [selectedYear, setSelectedYear] = useState(moment().year());
    const [loadingModal, setLoadingModal] = useState(false);
    const [loadingText, setLoadingText] = useState("Uploading...");
    const titlePage = 'Time Off Summary';

    const columns = [
        {
            title: 'No',
            render: (text, record, index) =>
                (page.pagination.current - 1) * page.pagination.pageSize + (index + 1),
        },
        { title: 'User Code', dataIndex: 'users_code' },
        { title: 'Name', dataIndex: 'name' },
        { title: 'Division', dataIndex: 'division' },
        { title: 'Position', dataIndex: 'position' },
        {
            title: 'Leave Earned',
            render: (_, record) => Number(record.leave_paid_default || 0) + Number(record.leave_obtained || 0),
        },
        {
            title: 'Admin Cut', dataIndex: 'cut_leave', render: value => {
                const cut = Number(value || 0);
                return cut === 0 ? 0 : -Math.abs(cut);
            }
        },
        { title: 'Used', dataIndex: 'leave_used' },
        { title: 'Remaining', dataIndex: 'total_leave_end' },
        {
            title: 'Action',
            render: (text, record) => (
                <Tooltip title="View Detail">
                    <Button
                        type="default"
                        onClick={() => openDetail(record)}
                    >
                        <UnorderedListOutlined />
                    </Button>
                </Tooltip>
            )
        }
    ];

    const getData = () => {
        setLoading(true);
        const url = `/user-leavepaid?page=${page.pagination.current}&limit=${page.pagination.pageSize}&search=${search}`;
        const req = {
            method: "GET",
            url: url,
            data: { headers: { Authorization: 'Bearer ' + token } }
        };
        apiCall(req).then(res => {
            if (res.status === "success") {
                setData(res.data.data);
                setPage({
                    pagination: {
                        ...page.pagination,
                        total: res.data.total_data
                    }
                });
            }
            setLoading(false);
        });
    };

    const getDetail = (userId) => {
        setLoading(true);
        const req = {
            method: "GET",
            url: `/user-leavepaid/${userId}`,
            data: { headers: { Authorization: 'Bearer ' + token } }
        };

        apiCall(req).then(res => {
            setDetailData(res.data);
            setLeaveHistory({
                period: res.data.details || [],
                usedHistory: res.data.history_leave_paid || []
            });
            setLoading(false);
        });
    };

    const openDetail = (record) => {
        getDetail(record.users_id);
        setIsModalDetail(true);
    };

    const handleTableChange = (pagination) => {
        setPage({ pagination });
    };

    useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(page), load]);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    const searchData = value => {
        setLoad(load + 1)
        setSearch(value);
        setPage({
            pagination: { current: 1, pageSize: 10 }
        });
    };

    const openForm = (mode, record = null) => {
        setFormMode(mode);
        setFormData(record);

        if (mode === "edit" && record) {
            setLeaveAction(Number(record.cut_leave || 0) > 0 ? "cut" : "add");
        } else {
            setLeaveAction(null);
        }

        setIsModalForm(true);
    };

    const submitForm = (values) => {
        setLoading(true);

        const payload = {
            ...values,
            leave_paid_default: leaveAction === "add" ? Number(values.leave_paid_default || 0) : 0,
            leave_obtained: leaveAction === "add" ? Number(values.leave_obtained || 0) : 0,
            cut_leave: leaveAction === "cut" ? Number(values.cut_leave || 0) : 0,
            date_start: leaveAction === "add" && values.date_start ? values.date_start.format("YYYY-MM-DD") : null,
            date_end: leaveAction === "add" && values.date_end ? values.date_end.format("YYYY-MM-DD") : null,
            notes: values.notes || "",
            users_id: detailData.users_id,
        };

        const req = {
            method: formMode === "add" ? "POST" : "PUT",
            url: formMode === "add"
                ? "/userleavepaid"
                : `/userleavepaid/${formData.user_leave_paid_id}`,
            data: {
                data: payload,
                headers: { Authorization: "Bearer " + token }
            }
        };

        apiCall(req).then(res => {
            setLoading(false);

            if (res?.status === "success") {
                setIsModalForm(false);

                Modal.success({
                    title: "Submitted for approval",
                    content: res.message || "The change has been submitted and is waiting for approval."
                });

                return;
            }

            Modal.error({
                title: "Submission failed",
                content: res?.message || res?.msg || "Unable to submit the leave period change."
            });
        }).catch(() => {
            setLoading(false);
            Modal.error({
                title: "Submission failed",
                content: "Unable to submit the leave period change."
            });
        });
    };

    const deletePeriod = (record) => {
        Modal.confirm({
            title: "Are you sure?",
            onOk: () => {
                const req = {
                    method: "DELETE",
                    url: `/userleavepaid/${record.user_leave_paid_id}`,
                    data: { headers: { Authorization: "Bearer " + token } }
                };

                apiCall(req).then(() => getDetail(detailData.users_id));
            }
        });
    };

    const propsFile = {
        onRemove: file => {
            setFileList(prev => prev.filter(item => item.uid !== file.uid));
        },
        beforeUpload: file => {
            setFileList([file]);
            return false;
        },
        fileList,
    };

    const handleUpload = () => {

        if (fileList.length > 0) {

            setLoading(true);
            setLoadingText("Uploading Excel file...");
            setLoadingModal(true);

            const formData = new FormData();

            if (selectedExcel !== "change") {
                formData.append("date_start", startDate);
                formData.append("date_end", endDate);
            }

            formData.append("file", fileList[0]);

            let url = "/upload/leavepaid";

            if (selectedExcel === "talenta") {
                url = "/upload/leavepaid/talenta";
            }

            if (selectedExcel === "change") {
                url = "/upload/leavepaid/change";
            }

            const req = {
                method: "POST",
                url: url,
                data: {
                    data: formData,
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: "Bearer " + token
                    }
                }
            };
            apiCall(req).then((res) => {

                setLoadingModal(false);
                if (selectedExcel === "change") {
                    if (res.status === "failed" || res.status === "completed") {

                        const columns = [
                            {
                                title: "No",
                                dataIndex: "no",
                                key: "no",
                                width: 60
                            },
                            {
                                title: "User Code",
                                dataIndex: "user_code",
                                key: "user_code",
                                width: 120
                            },
                            {
                                title: "Name",
                                dataIndex: "name",
                                key: "name",
                                width: 180
                            },
                            {
                                title: "Error Message",
                                dataIndex: "message",
                                key: "message"
                            }
                        ];

                        const data = res.errors?.map((e, i) => ({
                            key: i,
                            no: i + 1,
                            user_code: e.user_code,
                            name: e.name,
                            message: e.message
                        }));

                        Modal.error({
                            title: "Import Error",
                            width: 850,
                            content: (
                                <div>
                                    <Button
                                        type="primary"
                                        style={{ marginBottom: 10 }}
                                        onClick={() => exportErrorExcel(data)}
                                    >
                                        Export Error Excel
                                    </Button>

                                    <Table
                                        columns={columns}
                                        dataSource={data}
                                        pagination={false}
                                        size="small"
                                        scroll={{ y: 300 }}
                                    />
                                </div>
                            )
                        });
                    }
                }

                setFileList([]);
                setIsModalUpload(false);
                setLoading(false);
                getData();
            });

        } else {

            Modal.error({
                title: "Error",
                content: "Please select Excel file!"
            });

        }
    };

    const exportErrorExcel = (data) => {

        const exportData = data.map((d) => ({
            No: d.no,
            "User Code": d.user_code,
            "Name": d.name,
            "Error Message": d.message
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Import Errors");

        XLSX.writeFile(workbook, "import_leave_errors.xlsx");
    };

    const handleDownloadTemplate = () => {

        let fileName = "DATA_LEAVE_PAID_EMPLOYEE.xlsx";

        if (selectedExcel === "change") {
            fileName = "DATA_CHANGE_USER_LEAVE.xlsx";
        }

        // if (selectedExcel === "talenta") {
        //     fileName = "DATA_LEAVE_TALENTA.xlsx"; // kalau ada nanti
        // }

        const link = document.createElement("a");

        link.href = `${process.env.PUBLIC_URL}/assets/excel/${fileName}`;
        link.download = fileName;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleExportExcel = () => {
        const req = {
            method: "GET",
            url: "/user-leavepaid?nopage=true",
            data: { headers: { Authorization: "Bearer " + token } }
        };

        apiCall(req).then(res => {
            exportToExcel(res.data.data, selectedYear, selectedExcel);
            setIsModalExport(false);
        });
    };

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            <h3>{titlePage}</h3>

            <Row style={{ marginBottom: 20 }}>
                <Col span={12}>
                    <Input.Search
                        placeholder="Search employee"
                        allowClear
                        onSearch={searchData}
                        enterButton
                        style={{ width: 300 }}
                    />
                </Col>

                <Col span={12} style={{ textAlign: "right" }}>
                    <Button type="primary" style={{ marginRight: 10 }} onClick={() => setIsModalUpload(true)}>
                        Import Excel
                    </Button>

                    <Button type="default" onClick={() => setIsModalExport(true)}>
                        Export Excel
                    </Button>
                </Col>
            </Row>

            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
                rowKey={record => record.users_id}
            />

            <Modal
                title={null}
                open={isModalDetail}
                onCancel={() => setIsModalDetail(false)}
                footer={null}
                width={1050}
                centered
                styles={{ body: { padding: 0 } }}
            >
                {detailData && (() => {
                    const totalEarned = Number(detailData.leave_paid_default || 0) + Number(detailData.leave_obtained || 0);
                    const totalAdminCut = (leaveHistory.period || []).reduce(
                        (sum, item) => sum + Number(item.cut_leave || 0),
                        0
                    );

                    return (
                        <div>
                            <div
                                style={{
                                    padding: '24px 28px',
                                    borderBottom: '1px solid #f0f0f0',
                                    background: '#fafafa',
                                    borderRadius: '8px 8px 0 0'
                                }}
                            >
                                <Row align="middle" justify="space-between" gutter={[16, 16]}>
                                    <Col>
                                        <Space align="center" size="large">
                                            <Avatar size={72} src={detailData.image} />
                                            <div>
                                                <Typography.Title level={4} style={{ margin: 0 }}>
                                                    {detailData.name}
                                                </Typography.Title>
                                                <Typography.Text type="secondary" style={{ display: 'block', marginTop: 4 }}>
                                                    {detailData.users_code} · {detailData.position || '-'}
                                                </Typography.Text>
                                                <Typography.Text type="secondary">
                                                    {detailData.division || '-'}
                                                </Typography.Text>
                                            </div>
                                        </Space>
                                    </Col>
                                    <Col>
                                        <Button type="primary" onClick={() => openForm("add")}>Add / Cut Leave</Button>
                                    </Col>
                                </Row>
                            </div>

                            <div style={{ padding: '22px 28px 10px' }}>
                                <Row gutter={[12, 12]}>
                                    <Col xs={24} sm={12} md={6}>
                                        <Card size="small">
                                            <Statistic title="Leave Earned" value={totalEarned} suffix="day" />
                                            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                Default + Bonus
                                            </Typography.Text>
                                        </Card>
                                    </Col>
                                    <Col xs={24} sm={12} md={6}>
                                        <Card size="small">
                                            <Statistic
                                                title="Admin Cut"
                                                value={totalAdminCut === 0 ? 0 : -Math.abs(totalAdminCut)}
                                                suffix="day"
                                            />
                                            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                Total deducted by admin
                                            </Typography.Text>
                                        </Card>
                                    </Col>
                                    <Col xs={24} sm={12} md={6}>
                                        <Card size="small">
                                            <Statistic title="Used" value={Number(detailData.leave_used || 0)} suffix="day" />
                                        </Card>
                                    </Col>
                                    <Col xs={24} sm={12} md={6}>
                                        <Card size="small">
                                            <Statistic title="Remaining" value={Number(detailData.total_leave_end || 0)} suffix="day" />
                                        </Card>
                                    </Col>
                                </Row>
                            </div>

                            <div style={{ padding: '8px 28px 28px' }}>
                                <Tabs
                                    defaultActiveKey="period"
                                    items={[
                                        {
                                            key: 'period',
                                            label: 'Leave Period Summary',
                                            children: (
                                                <div>
                                                <Table
                                                    size="small"
                                                    columns={[
                                                        { title: "Start", dataIndex: "date_start", render: d => d ? moment(d).format("YYYY-MM-DD") : "-" },
                                                        { title: "End", dataIndex: "date_end", render: d => d ? moment(d).format("YYYY-MM-DD") : "-" },
                                                        {
                                                            title: "Leave Earned",
                                                            render: (_, record) => Number(record.leave_paid_default || 0) + Number(record.leave_obtained || 0)
                                                        },
                                                        {
                                                            title: "Admin Cut", dataIndex: "cut_leave", render: value => {
                                                                const cut = Number(value || 0);
                                                                return cut === 0 ? 0 : -Math.abs(cut);
                                                            }
                                                        },
                                                        { title: "Used", dataIndex: "leave_used", render: value => Number(value || 0) },
                                                        { title: "Notes", dataIndex: "notes", render: value => value || "-" },
                                                        {
                                                            title: "Input By",
                                                            dataIndex: "created_by_name",
                                                            width: 160,
                                                            render: (value, record) => value || (Number(record.created_by || 0) > 0 ? `User #${record.created_by}` : "System")
                                                        },
                                                        {
                                                            title: "Last Updated By",
                                                            dataIndex: "updated_by_name",
                                                            width: 170,
                                                            render: (value, record) => value || (Number(record.updated_by || 0) > 0 ? `User #${record.updated_by}` : "-")
                                                        },
                                                        {
                                                            title: "Status",
                                                            dataIndex: "status",
                                                            render: s => <Tag color={s ? "green" : "default"}>{s ? "Active" : "Inactive"}</Tag>
                                                        },
                                                        {
                                                            title: "Action",
                                                            width: 145,
                                                            render: (_, record) => (
                                                                <Space>
                                                                    <Button type="primary" size="small" onClick={() => openForm("edit", record)}>Edit</Button>
                                                                    <Button danger size="small" onClick={() => deletePeriod(record)}>Delete</Button>
                                                                </Space>
                                                            )
                                                        }
                                                    ]}
                                                    dataSource={leaveHistory.period}
                                                    rowKey={record => record.user_leave_paid_id}
                                                    pagination={false}
                                                    scroll={{ x: 1180 }}
                                                />

                                                <Card
                                                    size="small"
                                                    title="Activity Log"
                                                    style={{ marginTop: 18 }}
                                                    bodyStyle={{ padding: 0 }}
                                                >
                                                    <Table
                                                        size="small"
                                                        pagination={false}
                                                        scroll={{ x: 760 }}
                                                        rowKey={(record) => record.key}
                                                        dataSource={(leaveHistory.period || [])
                                                            .flatMap((record) => {
                                                                const period = record.date_start && record.date_end
                                                                    ? `${moment(record.date_start).format("YYYY-MM-DD")} - ${moment(record.date_end).format("YYYY-MM-DD")}`
                                                                    : "Administrative adjustment";
                                                                const rows = [{
                                                                    key: `created-${record.user_leave_paid_id}`,
                                                                    activity: "Created",
                                                                    actor: record.created_by_name || (Number(record.created_by || 0) > 0 ? `User #${record.created_by}` : "System"),
                                                                    time: record.created_at,
                                                                    period,
                                                                    notes: record.notes || "-"
                                                                }];

                                                                if (record.updated_at) {
                                                                    rows.push({
                                                                        key: `updated-${record.user_leave_paid_id}`,
                                                                        activity: "Updated",
                                                                        actor: record.updated_by_name || (Number(record.updated_by || 0) > 0 ? `User #${record.updated_by}` : "System"),
                                                                        time: record.updated_at,
                                                                        period,
                                                                        notes: record.notes || "-"
                                                                    });
                                                                }
                                                                return rows;
                                                            })
                                                            .sort((a, b) => new Date(b.time || 0) - new Date(a.time || 0))}
                                                        columns={[
                                                            {
                                                                title: "Activity",
                                                                dataIndex: "activity",
                                                                width: 105,
                                                                render: value => <Tag color={value === "Created" ? "blue" : "gold"}>{value}</Tag>
                                                            },
                                                            { title: "User", dataIndex: "actor", width: 180, render: value => value || "System" },
                                                            {
                                                                title: "Date & Time",
                                                                dataIndex: "time",
                                                                width: 175,
                                                                render: value => value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "-"
                                                            },
                                                            { title: "Leave Period", dataIndex: "period", width: 220 },
                                                            { title: "Notes", dataIndex: "notes", render: value => value || "-" }
                                                        ]}
                                                        locale={{ emptyText: "No activity log available" }}
                                                    />
                                                </Card>
                                            </div>
                                            )
                                        },
                                        {
                                            key: 'usage',
                                            label: 'Leave Usage History',
                                            children: (
                                                <Table
                                                    size="small"
                                                    columns={[
                                                        { title: "Date", dataIndex: "date", render: d => d ? moment(d).format("YYYY-MM-DD") : "-" },
                                                        { title: "Leave Type", dataIndex: "leave_type", render: lt => lt ? lt.name : "Admin" },
                                                        { title: "Duration", dataIndex: "total_leave" },
                                                        { title: "Description", dataIndex: "desc", render: value => value || "-" },
                                                        { title: "Status", dataIndex: "status" },
                                                    ]}
                                                    dataSource={leaveHistory.usedHistory}
                                                    rowKey={record => record.leave_paid_id}
                                                    pagination={false}
                                                    scroll={{ x: 700 }}
                                                />
                                            )
                                        }
                                    ]}
                                />
                            </div>
                        </div>
                    );
                })()}
            </Modal>

            <Modal
                title={formMode === "add" ? "Manage Leave" : "Edit Leave"}
                open={isModalForm}
                onCancel={() => {
                    setIsModalForm(false);
                    setLeaveAction(null);
                }}
                footer={null}
                width={500}
                destroyOnClose
            >
                <Alert
                    type="info"
                    showIcon
                    style={{ marginBottom: 16 }}
                    message="Approval required"
                    description="This change will be applied after it is approved."
                />

                <div style={{ marginBottom: 20 }}>
                    <Typography.Text strong style={{ display: 'block', marginBottom: 8 }}>
                        Select Action
                    </Typography.Text>
                    <Radio.Group
                        value={leaveAction}
                        onChange={(e) => setLeaveAction(e.target.value)}
                        buttonStyle="solid"
                        style={{ width: '100%', display: 'flex' }}
                    >
                        <Radio.Button value="add" style={{ flex: 1, textAlign: 'center' }}>
                            Add Leave
                        </Radio.Button>
                        <Radio.Button value="cut" style={{ flex: 1, textAlign: 'center' }}>
                            Cut Leave
                        </Radio.Button>
                    </Radio.Group>
                </div>

                {!leaveAction ? (
                    <Alert
                        type="warning"
                        showIcon
                        message="Choose Add Leave or Cut Leave first."
                    />
                ) : (
                    <Form
                        layout="vertical"
                        onFinish={submitForm}
                        initialValues={
                            formMode === "edit"
                                ? {
                                    leave_paid_default: formData?.leave_paid_default,
                                    leave_obtained: formData?.leave_obtained,
                                    cut_leave: formData?.cut_leave,
                                    notes: formData?.notes,
                                    date_start: formData?.date_start ? dayjs(formData.date_start) : null,
                                    date_end: formData?.date_end ? dayjs(formData.date_end) : null,
                                }
                                : {}
                        }
                    >
                        {leaveAction === "add" && (
                            <>
                                <Row gutter={12}>
                                    <Col span={12}>
                                        <Form.Item
                                            name="leave_paid_default"
                                            label="Default Leave"
                                            rules={[{ required: formMode === "add", message: "Input default leave" }]}
                                        >
                                            <InputNumber
                                                placeholder="Default leave"
                                                min={0}
                                                style={{ width: "100%" }}
                                                disabled={formMode === "edit"}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item name="leave_obtained" label="Bonus Leave">
                                            <InputNumber
                                                placeholder="Bonus leave"
                                                min={0}
                                                style={{ width: "100%" }}
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Row gutter={12}>
                                    <Col span={12}>
                                        <Form.Item
                                            name="date_start"
                                            label="Start Date"
                                            rules={[{ required: true, message: "Select start date" }]}
                                        >
                                            <DatePicker
                                                style={{ width: "100%" }}
                                                placeholder="Start date"
                                                format="YYYY-MM-DD"
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item
                                            name="date_end"
                                            label="End Date"
                                            rules={[{ required: true, message: "Select end date" }]}
                                        >
                                            <DatePicker
                                                style={{ width: "100%" }}
                                                placeholder="End date"
                                                format="YYYY-MM-DD"
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </>
                        )}

                        {leaveAction === "cut" && (
                            <Form.Item
                                name="cut_leave"
                                label="Cut Leave"
                                rules={[{ required: true, message: "Input leave deduction" }]}
                            >
                                <InputNumber
                                    placeholder="Input leave deduction"
                                    min={0.5}
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                        )}

                        <Form.Item name="notes" label="Notes">
                            <Input.TextArea
                                rows={3}
                                placeholder={leaveAction === "cut" ? "Reason for leave deduction" : "Notes about this leave period"}
                            />
                        </Form.Item>

                        <div style={{ marginTop: 10, textAlign: "right" }}>
                            <Button
                                onClick={() => {
                                    setIsModalForm(false);
                                    setLeaveAction(null);
                                }}
                                style={{ marginRight: 10 }}
                            >
                                Cancel
                            </Button>

                            <Button htmlType="submit" type="primary" loading={loading}>
                                Submit for Approval
                            </Button>
                        </div>
                    </Form>
                )}
            </Modal>

            <Modal
                title="Import Excel Time Off"
                open={isModalUpload}
                onOk={handleUpload}
                onCancel={() => setIsModalUpload(false)}
                okText={loading ? <Spin /> : "Upload"}
            >
                <Divider />
                {selectedExcel !== "change" && (
                    <>
                        <Divider />
                        <DatePicker.RangePicker
                            style={{ width: "100%" }}
                            format="YYYY-MM-DD"
                            onChange={(dates, dateStrings) => {
                                setStartDate(dateStrings[0]);
                                setEndDate(dateStrings[1]);
                            }}
                        />
                    </>
                )}

                <Divider />
                <Radio.Group
                    onChange={(e) => setSelectedExcel(e.target.value)}
                    value={selectedExcel}
                >
                    <Radio value="access">Excel Access</Radio>
                    <Radio value="change">Excel Change Bonus/Cut</Radio>
                    {/* <Radio value="talenta">Excel Talenta</Radio> */}
                </Radio.Group>
                {selectedExcel === "change" && (
                    <>
                        <Divider />
                        <Alert
                            type="info"
                            message="Bonus/Cut Leave import. Start-End Date follow Excel or current year automatically."
                        />
                    </>
                )}
                <br />
                <br />
                {(selectedExcel === "access" || selectedExcel === "change") && (
                    <>
                        <Button type="primary" onClick={handleDownloadTemplate} style={{ marginTop: 10 }}>
                            Download Template
                        </Button>
                        <Upload {...propsFile} maxCount={1}>
                            <Button icon={<UploadOutlined />} disabled={fileList.length > 0} style={{ marginLeft: 10 }}>
                                Import Excel
                            </Button>
                        </Upload>
                    </>
                )}
            </Modal>

            <Modal
                title="Export Time Off Data"
                open={isModalExport}
                onOk={handleExportExcel}
                onCancel={() => setIsModalExport(false)}
                okText="Export"
            >

                <Typography.Text strong>
                    Select Year
                </Typography.Text>

                <Select
                    value={selectedYear}
                    onChange={setSelectedYear}
                    style={{ width: "100%", marginBottom: 15 }}
                >
                    {Array.from({ length: 5 }, (_, i) => {
                        const year = moment().year() - i;
                        return (
                            <Select.Option key={year} value={year}>
                                {year}
                            </Select.Option>
                        );
                    })}
                </Select>


                <Typography.Text strong>
                    Excel Type
                </Typography.Text>

                <Radio.Group
                    onChange={(e) => setSelectedExcel(e.target.value)}
                    value={selectedExcel}
                    style={{ width: "100%", marginTop: 10 }}
                >
                    <Space direction="vertical">

                        <Radio value="access">
                            Excel Access (Default Leave)
                        </Radio>

                        <Radio value="change">
                            Excel Change Bonus / Cut
                        </Radio>

                    </Space>

                </Radio.Group>

            </Modal>

            <Modal
                open={loadingModal}
                footer={null}
                closable={false}
                centered
            >
                <div style={{ textAlign: "center", padding: 20 }}>
                    <Spin size="large" />
                    <div style={{ marginTop: 15, fontSize: 16 }}>
                        {loadingText}
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default LeavePaidTimeOffNew;
